module.exports = __webpack_public_path__ + "static/media/theatlantic_magazine_archive_2016_06_the-mind-of-donald-trump_480771__plot.026fb78b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/theatlantic_magazine_archive_2016_06_the-mind-of-donald-trump_480771__plot.png
// module id = 424
// module chunks = 0